import { useMemo } from 'react';

import type { FactsheetDetails } from '@/features/Factsheet';
import useSelectionFunctions from '@/hooks/useSelectionFunctions';

const useItemsTab = (factsheet: FactsheetDetails) => {
  const { addAllSymbolsToSelection, allSymbolsSelected, removeSymbolsFromSelection } =
    useSelectionFunctions();

  const symbols = useMemo(
    () =>
      factsheet.symbols.map(symbol => {
        return {
          Code: factsheet.code,
          Period: symbol.period,
          PeriodType: symbol.periodType,
          TimeRef: symbol.timeRef
        };
      }),
    [factsheet]
  );

  const allItemsSelected = useMemo((): boolean => {
    if (symbols.length < 1) return false;
    return allSymbolsSelected(symbols);
  }, [allSymbolsSelected, symbols]);

  const clearAllCodesFromSelection = () => {
    removeSymbolsFromSelection(symbols);
  };

  const addAllCodesToSelection = () => {
    addAllSymbolsToSelection(symbols);
  };

  const handleAllItemsSelection = () => {
    if (allItemsSelected) {
      clearAllCodesFromSelection();
    } else {
      addAllCodesToSelection();
    }
  };
  return { handleAllItemsSelection, allItemsSelected };
};
export default useItemsTab;
